var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-div"},[_c('div',{attrs:{"id":"vs"}}),(!_vm.fromApp)?_c('div',{staticClass:"close-icon"},[_c('i',{staticClass:"iconfont icon-close-solid",on:{"click":function($event){$event.stopPropagation();return _vm.closeAudio.apply(null, arguments)}}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }